import { render, staticRenderFns } from "./sup-about-shop.vue?vue&type=template&id=8fcd9266"
import script from "./sup-about-shop.vue?vue&type=script&lang=js"
export * from "./sup-about-shop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports